import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import VolumeUp from 'material-ui/svg-icons/av/volume-up';
import Stop from 'material-ui/svg-icons/av/stop';

import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

import RateSlider from './RateSlider';

const iconStyles = {
  color: '#fff',
};

const PlayExample = (props) => {
  if (!props.deviceConfig.supportsTTS) {
    return <span />;
  }

  const disabled = props.mode === 'flipped' && props.text.texts[props.text.activeText].results.length === 0;

  console.log(disabled);
  console.log(props.mode);
  console.log(props.text.texts[props.text.activeText].results.length);

  const isActive = (props.isStopped() || props.isPlayingExample)
                    && props.text.texts.length > 0
                    && props.text.texts[props.text.activeText].source.length > 0
                    && props.voices.length > 0
                    && !disabled;


  const label = props.isPlayingExample
            ? <Stop />
            : <VolumeUp />;
  return (
    <span>
      <FloatingActionButton
        id="listen"
        title="Listen example"
        backgroundColor="#d52b1e"
        iconStyle={iconStyles}
        onClick={props.togglePlayExample}
        disabled={!isActive}
      >
        {label}
      </FloatingActionButton>
      <div className="listenBlock">
        <span>Listen</span>
        <IconMenu
            iconButtonElement={<IconButton style={{padding: 0, width: 0, height: 0, marginTop: '-3px'}}><MoreVertIcon /></IconButton>}
            anchorOrigin={{horizontal: 'left', vertical: 'top'}}
            targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
            listStyle={{paddingTop: 0, paddingBottom: 0, overflow: 'hidden', width: 150}}
            children={<RateSlider isStopped={props.isStopped} rate={props.rate} setRate={props.setRate} />}
        >

        </IconMenu>
      </div>
    </span>
        );
};

export default PlayExample;



// WEBPACK FOOTER //
// ./src/components/PlayExample.js